import deprecate from 'util-deprecate';
var Character = /** @class */ (function () {
    function Character(props) {
        this.id = props.id;
        this.resourceName = props.resourceName;
        this.displayName = props.displayName;
        this.assets = props.assets;
    }
    Character.prototype.getId = function () {
        return this.id;
    };
    Character.prototype.getResourceName = function () {
        return this.resourceName;
    };
    Character.prototype.getDisplayName = function () {
        return this.displayName;
    };
    Character.prototype.getAssets = function () {
        return this.assets;
    };
    return Character;
}());
export { Character };
Character.prototype.getId = deprecate(Character.prototype.getId, 'getId() is deprecated. Use `id` property instead.');
Character.prototype.getResourceName = deprecate(Character.prototype.getResourceName, 'getResourceName() is deprecated. Use `desourceName` property instead.');
Character.prototype.getDisplayName = deprecate(Character.prototype.getDisplayName, 'getDisplayName() is deprecated. Use `displayName` property instead.');
Character.prototype.getAssets = deprecate(Character.prototype.getAssets, 'getAssets() is deprecated. Use `assets` property instead.');
